import Counter from './modules/counter';

const App = () => {
    return (
        <div className="App">
            <Counter/>
        </div>
    );
}

export default App;
